import type { ViewPreset } from './presets';

// Default secondary text color (Brand theme D30). Used when a preset does not
// set its own `secondaryTextColor`. Kept next to the CSS-var mapping so the
// static stylesheet and the client runtime never drift apart.
export const DEFAULT_SECONDARY_TEXT_COLOR = '#595D70';

// Single source of truth for the CSS custom properties a preset contributes to
// `document.documentElement` (`:root`).
//
// Consumed by:
//   - the client runtime — `DisplayStore.initCssVariables()` (setProperty), and
//   - the build-time generator (scripts/generate-preset-css.cjs), which emits the
//     render-blocking static stylesheet (common/styles/presetVars.global.css,
//     gitignored) from the same mapping for every userType-keyed branded preset.
//
// The generated stylesheet is what themes the very first paint (keyed on
// <html data-preset="...">); this runtime call then re-asserts the identical
// values, so there is no visible "hop" from the default WDS tokens. Because both
// derive from this one function + presets.ts, the values are never duplicated.
export const getPresetCssVars = (
  preset: ViewPreset,
): Record<string, string> => ({
  ...(preset.cssVariables ?? {}),
  // Applied after the spread so an explicit override always wins, matching the
  // original initCssVariables() ordering.
  '--secondary-text-color-override':
    preset.secondaryTextColor || DEFAULT_SECONDARY_TEXT_COLOR,
});
